export default async function externalComponent(id, url) {
  const name = url.split('/').reverse()[0].match(/^(.*?)\.umd/)[1]
  const parsedUrl = window.location.origin + '/' + url.substring(0, url.lastIndexOf('/'))
  window[name] = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.async = true
    script.id = id
    script.addEventListener('load', () => {
      resolve(window[name])
    })
    script.addEventListener('error', () => {
      reject(new Error(`Error loading component ${parsedUrl}`))
    })
    script.src = parsedUrl
    document.head.appendChild(script)
  })

  return window[name]
}